export default __webpack_public_path__ + "static/media/history.96945db0.svg";